import styled from 'styled-components';

export const GIF = styled.img`
  margin: 20px 0 0;
  max-width: 100px;
  width: 100%;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    margin: 20px;
  }
`;

export const Title = styled.h2`
  font-size: calc(${props => props.theme.fonts.baseSize} + 1.1vmin);
  margin: 20px;

  span {
    color: ${props => props.theme.colors.quaternary};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: calc(${props => props.theme.fonts.baseSize} + 1.25vmin);
  }
`;

export const Para = styled.p`
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.1vmin);
  line-height: 1.35;
  margin: 20px 15px;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: calc(${props => props.theme.fonts.baseSize} + 0.2vmin);
  }
`;

const HowToNoodle = styled.section`
  color: ${props => props.theme.colors.tertiary};
  max-width: 300px;
`;

export default HowToNoodle;



// WEBPACK FOOTER //
// ./src/components/atoms/HowToNoodle/HowToNoodle.styled.js